<h2 mat-dialog-title>
  Ansøgningsscore
  <mat-divider></mat-divider>
</h2>
<mat-dialog-content>
  <form [formGroup]="form" fxFlex="100" fxLayout="column" fxLayoutGap="10px">
    @for (value of range.controls; track value; let i = $index) {
      <div
        formArrayName="range"
        class="mb-3"
        >
        <div [formGroupName]="i" class="category" fxLayout="row" fxLayoutAlign="space-between center">
          <span fxFlex="5">#{{i + 1}}</span>
          <mat-form-field color="primary" class="mr-3" fxFlex="37">
            <mat-label>Label</mat-label>
            <input
              type="text"
              matInput
              formControlName="label"
              placeholder="Label"
              >
          </mat-form-field>
          <mat-form-field color="primary" fxFlex="37">
            <mat-label>Score værdi</mat-label>
            <input
              type="number"
              matInput
              formControlName="value"
              placeholder="Score værdi"
              >
          </mat-form-field>
          <div fxFlex="20" fxLayoutAlign="end">
            @if (range.length >= 1) {
              <button
                mat-icon-button
                matTooltip="Slet score"
                matTooltipPosition="above"
                (click)="doRemoveScore(i)"
                ><mat-icon>delete</mat-icon></button>
              }
            </div>
            @if (i < range.length - 1) {
              <mat-divider></mat-divider>
            }
          </div>
        </div>
      }
      <button
        mat-flat-button
        matTooltip="Tilføj ny score"
        (click)="doAppendScore()"
        ><mat-icon>add</mat-icon>Tilføj score</button>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button mat-dialog-close>Luk</button>
      <button mat-flat-button [disabled]="form.invalid" (click)="doSave()">Gem</button>
    </mat-dialog-actions>
